export default __webpack_public_path__ + "static/media/cv-rewards-button.73d4eebe.svg";